import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

import styles from './FallbackLoader.module.scss';

const FallbackLoader: React.FC = () => (
  <div className={styles.container}>
    <CircularProgress color="inherit" />
  </div>
);

export default FallbackLoader;
